/*
Copyright © 2015 Infrared5, Inc. All rights reserved.

The accompanying code comprising examples for use solely in conjunction with Red5 Pro (the "Example Code")
is  licensed  to  you  by  Infrared5  Inc.  in  consideration  of  your  agreement  to  the  following
license terms  and  conditions.  Access,  use,  modification,  or  redistribution  of  the  accompanying
code  constitutes your acceptance of the following license terms and conditions.

Permission is hereby granted, free of charge, to you to use the Example Code and associated documentation
files (collectively, the "Software") without restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit
persons to whom the Software is furnished to do so, subject to the following conditions:

The Software shall be used solely in conjunction with Red5 Pro. Red5 Pro is licensed under a separate end
user  license  agreement  (the  "EULA"),  which  must  be  executed  with  Infrared5,  Inc.
An  example  of  the EULA can be found on our website at: https://account.red5pro.com/assets/LICENSE.txt.

The above copyright notice and this license shall be included in all copies or portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,  INCLUDING  BUT
NOT  LIMITED  TO  THE  WARRANTIES  OF  MERCHANTABILITY, FITNESS  FOR  A  PARTICULAR  PURPOSE  AND
NONINFRINGEMENT.   IN  NO  EVENT  SHALL INFRARED5, INC. BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN  AN  ACTION  OF  CONTRACT,  TORT  OR  OTHERWISE,  ARISING  FROM,  OUT  OF  OR  IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => {
  return {
    container: {
      height: '100vh',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 'auto',
        flexDirection: 'column',
      },
    },
    leftContainer: {
      background: 'linear-gradient(to bottom right, #1b1828,#2a448a)',
      backdropFilter: 'blur(88px)',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingLeft: '15%',
      width: '60%',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    titleContainer: {
      margin: '2.5rem 0',
    },
    title: {
      fontSize: '90px',
      fontWeight: '600',
      lineHeight: '104px',
      letterSpacing: '-0.018em',
    },
    subtitle: {
      fontSize: '24px',
      fontWeight: 500,
      lineHeight: '32px',
    },
    partyCode: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '25.65px',
    },
    input: {},
    link: {
      fontWeight: 600,
    },
    rightContainer: {
      width: '40%',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 'auto',
      },
    },
    imageContainer: {
      width: '100%',
      height: '100vh',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 'auto',
      },
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'right',
    },
    errorValidation: {
      color: '#d32f2f',
      fontSize: '14px',
    },
  }
})

export default useStyles
